import { BulkImportPayeesRow } from '@willow/types-iso';

import { makeValidator } from '../shared/makeValidator';

export const validateBulkImportPayees = makeValidator({
  FieldParser: BulkImportPayeesRow,
});
